<template>
  <a class="idea" :href="'/idee/' + idea.id">
    <img
      class="title-img"
      alt="Idee Titelbild"
      :src="idea.images.length > 0 ? idea.images[0].path : idea.titleImage"
    />
    <div class="idea-information">
      <div class="info-1">
        <div class="idea-cat">{{ category_name }}</div>
        <div class="idea-title">{{ titleFixed }}</div>
        <div class="idea-rating">
          <span>{{ rating }}</span>

          <img alt="Bewertung" src="/img/icons/star.svg" />
        </div>
      </div>

      <div class="info-2">
        <div class="info-2-row1">
          <div class="icon-text">
            <img alt="Dauer" src="/img/icons/clock.svg" />
            {{ duration_output }}
          </div>
          <div class="icon-text">
            <img alt="Kosten" src="/img/icons/cash.svg" />
            {{ cost_output }}
          </div>
        </div>
        <div class="info-2-row2">
          <div class="icon-text">
            <img alt="Alter" src="/img/icons/people.svg" />
            {{ age_output }}
          </div>

          <div class="icon-text">
            <img alt="Indoor/Outdoor" src="/img/icons/house.svg" />
            {{ location_output }}
          </div>
        </div>
      </div>

      <div class="goto">
        <img alt="Zur Idee" src="/img/icons/arrow-right.svg" />
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: ["classes", "idea"],
  computed: {
    titleFixed: function () {
      const max = 70;
      return this.idea.title.length > max
        ? this.idea.title.substring(0, max) + "..."
        : this.idea.title;
    },
    rating: function () {
      return this.idea.average_rating
        ? parseFloat(this.idea.average_rating).toFixed(1)
        : "0.0";
    },

    duration_output: function () {
      let output = "";
      if (this.idea.duration_from == null && this.idea.duration_to == null) {
        output = "Keine Angabe";
      } else if (
        (this.idea.duration_from == 0 && this.idea.duration_to == null) ||
        (this.idea.duration_from == 0 && this.idea.duration_to == 0)
      ) {
        output = "0 Min.";
      } else if (
        this.idea.duration_from !== null &&
        this.idea.duration_to == null
      ) {
        if (this.idea.duration_from > 90) {
          output = this.idea.duration_from / 60 + " Std.";
        } else {
          output = this.idea.duration_from + " Min.";
        }
      } else {
        if (this.idea.duration_to > 90) {
          output =
            this.idea.duration_from / 60 +
            " - " +
            this.idea.duration_to / 60 +
            " Std.";
        } else {
          output =
            this.idea.duration_from + " - " + this.idea.duration_to + " Min.";
        }
      }

      return output;
    },
    category_name: function () {
      if (this.idea.subsubcategory !== null) {
        return this.idea.subsubcategory.title;
      } else if (this.idea.subcategory !== null) {
        return this.idea.subcategory.title;
      } else {
        return this.idea.category.title;
      }
    },
    cost_output: function () {
      let output = "";
      if (this.idea.price_from == null && this.idea.price_to == null) {
        output = "Keine Angabe";
      } else if (this.idea.price_from == 0 && this.idea.price_to == null) {
        output = "Gratis";
      } else if (this.idea.price_from !== null && this.idea.price_to == null) {
        output = this.idea.price_from + " CHF";
      } else {
        output = this.idea.price_from + " - " + this.idea.price_to + " CHF";
      }

      return output;
    },
    age_output: function () {
      let output = "";
      if (this.idea.age_from == null && this.idea.age_to == null) {
        output = "Keine Angabe";
      } else if (this.idea.age_from !== null && this.idea.age_to == null) {
        output = "Ab " + this.idea.age_from + " Jahren";
      } else if (this.idea.age_from !== null && this.idea.age_to !== null) {
        output = this.idea.age_from + " - " + this.idea.age_to + " Jahren";
      }
      return output;
    },
    location_output: function () {
      let output = "";
      if (this.idea.indoor == true && this.idea.outdoor == true) {
        return "Drinnen/Draussen";
      } else if (this.idea.indoor == false && this.idea.outdoor == false) {
        return "Keine Angabe";
      } else if (this.idea.indoor == true && this.idea.outdoor == false) {
        return "Drinnen";
      } else if (this.idea.indoor == false && this.idea.outdoor == true) {
        return "Draussen";
      }
    },
  },
  watch: {},
};
</script>

<style>
</style>
